import {Country, DSP} from "types/analytics";
import { styled } from "styled-components";
import { Column } from './types';
import {formatNumber, getComparativeValue} from "./utils";
import React from "react";
import Receive  from '../../assets/receive-square.svg';
import ReceiveCountry  from 'assets/receive.svg';

export enum ComparativeValue {
  More = "more",
  Equal = "equal",
  Less = "less",
}

export const countryColumns: Column[] = [
  {
    title: 'Countries',
    render: (data: Country) => {
      return (
        <CountryName>
          <CountryColor color={data.color} />
          <CountryText>{data.name ?? '-'}</CountryText>
        </CountryName>
      );
    },
    // width: '70%',
    flex: '3',
  },
  {
    title: 'Total streams',
    render: (data: Country) => data.total ? formatNumber(data.total) : '-',
    // width: '20%',
    flex: '2',
  },
  {
    title: (
        <div style={{display:'flex', alignItems:'center', width: '100%'}}>
          <span>Growth rate</span>
          <ReceiveCountry />
        </div>
    ),
    render: (data: Country) => {
      const growthpct = data.growth_pct;

      if (!growthpct) {
        return '-';
      }

      const comparativeValue = getComparativeValue(growthpct);

      return (
        <TableGrowthPCT comparativeValue={comparativeValue}>
          {growthpct}%
          {(() => {
            if (comparativeValue === ComparativeValue.Less) {
              return (
                <svg width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5.50503 10.495C5.77839 10.7683 6.22161 10.7683 6.49498 10.495L10.9497 6.0402C11.2231 5.76683 11.2231 5.32362 10.9497 5.05025C10.6764 4.77689 10.2332 4.77689 9.9598 5.05025L6 9.01005L2.0402 5.05025C1.76684 4.77689 1.32362 4.77689 1.05025 5.05025C0.776886 5.32362 0.776886 5.76684 1.05025 6.0402L5.50503 10.495ZM6 0L5.3 3.0598e-08L5.3 10L6 10L6.7 10L6.7 -3.0598e-08L6 0Z" fill="#FF6565"/>
                </svg>
              );
            }

            if (comparativeValue === ComparativeValue.More) {
              return (
                <svg width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6.49497 0.295064C6.22161 0.021697 5.77839 0.0216971 5.50502 0.295064L1.05025 4.74984C0.776885 5.0232 0.776885 5.46642 1.05025 5.73979C1.32362 6.01315 1.76684 6.01315 2.0402 5.73979L6 1.77999L9.9598 5.73979C10.2332 6.01315 10.6764 6.01315 10.9497 5.73979C11.2231 5.46642 11.2231 5.0232 10.9497 4.74984L6.49497 0.295064ZM6 10.79L6.7 10.79L6.7 0.790039L6 0.790039L5.3 0.790039L5.3 10.79L6 10.79Z" fill="#1DB954"/>
                </svg>
              );
            }

            return null;
          })()}
        </TableGrowthPCT>
      );
    },
    // width: '10%',
    flex: '1',
  },
];

export const streamsColumns: Column[] = [
  {
    title: 'Title',
    render: (data: DSP) => data.name ?? '-',
    // width: '70%',
    flex: '3',
  },
  {
    title: 'Streams',
    render: (data: DSP) => data.cur_plays ? formatNumber(data.cur_plays) : '-',
    // width: '20%',
    flex: '2',
  },
  {
    title: (
      <div style={{display:'flex', alignItems:'center', justifyContent: 'space-between', width: '100%'}}>
        <span>Streams change</span>
        <Receive />
      </div>
    ),    render: (data: DSP) => {
      const changepct = data.change_pct;

      if (!changepct) {
        return '-';
      }

      const comparativeValue = getComparativeValue(Number(changepct));

      return (
        <TableGrowthPCT comparativeValue={comparativeValue}>
          {changepct}% {(() => {
          if (comparativeValue === ComparativeValue.Less) {
            return (
              <svg width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.50503 10.495C5.77839 10.7683 6.22161 10.7683 6.49498 10.495L10.9497 6.0402C11.2231 5.76683 11.2231 5.32362 10.9497 5.05025C10.6764 4.77689 10.2332 4.77689 9.9598 5.05025L6 9.01005L2.0402 5.05025C1.76684 4.77689 1.32362 4.77689 1.05025 5.05025C0.776886 5.32362 0.776886 5.76684 1.05025 6.0402L5.50503 10.495ZM6 0L5.3 3.0598e-08L5.3 10L6 10L6.7 10L6.7 -3.0598e-08L6 0Z" fill="#FF6565"/>
              </svg>
            );
          }

          if (comparativeValue === ComparativeValue.More) {
            return (
              <svg width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.49497 0.295064C6.22161 0.021697 5.77839 0.0216971 5.50502 0.295064L1.05025 4.74984C0.776885 5.0232 0.776885 5.46642 1.05025 5.73979C1.32362 6.01315 1.76684 6.01315 2.0402 5.73979L6 1.77999L9.9598 5.73979C10.2332 6.01315 10.6764 6.01315 10.9497 5.73979C11.2231 5.46642 11.2231 5.0232 10.9497 4.74984L6.49497 0.295064ZM6 10.79L6.7 10.79L6.7 0.790039L6 0.790039L5.3 0.790039L5.3 10.79L6 10.79Z" fill="#1DB954"/>
              </svg>
            );
          }

          return null;
        })()}
        </TableGrowthPCT>
      );
    },
    // width: '10%',
    flex: '2',
  },
];

const TableGrowthPCT = styled.div<{ comparativeValue: ComparativeValue }>`
  color: ${props => {
    if (props.comparativeValue === ComparativeValue.Less) {
      return '#FF6565';
    }

    if (props.comparativeValue === ComparativeValue.More) {
      return '#1DB954';
    }

    return "#000000";
  }};
  font-family: SF Pro Display;
  font-weight: 400;
  font-style: Regular;
  font-size: 13px;
  leading-trim: NONE;
  line-height: 15px;
  letter-spacing: 0%;
  vertical-align: middle;
`;

const CountryName = styled.div`
  gap: 4px;
  align-items: center;
  display: grid;
  grid-template-columns: auto 1fr;
`;

const CountryColor = styled.div<{ color?: string }>`
  width: 11px;
  height: 11px;
  border-radius: 50%;
  background: ${props => props.color};
`;

const CountryText = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const TitleWithIcon = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;

  svg {
    width: 14px;
    height: 14px;
  }
`;

export const metricOptions = [
  { label: 'Streams', value: 'streams' },
  { label: 'Download', value: 'download' }
];

export const dimensionOptions = [
  { label: 'DSP', value: 'dsp' },
  { label: 'Territory', value: 'territory' },
  { label: 'Label', value: 'label' },
  { label: 'Artist', value: 'artist' },
  { label: 'Release', value: 'release' },
  { label: 'Track', value: 'track' }
];